import { isImageSeries } from '../../../study';
import { actionLabel } from '../actions';
import { conversationStudy, priorStudies } from '../context';
import { runCommandActions } from '../tools/command';
import { prepareBody } from './logic';
import { MAX_PREPARE_ACTIONS } from './shapes';
import { el, loading, type RadiologistDeps, toolCard, toolFailure, traceNodes } from './ui';

/**
 * "Preparar estudio" (contract v3 §2.5): the viewer tells ris which series and priors its study
 * browser holds; ris (the model, or a deterministic plan without it) answers a short reading plan as
 * viewer actions. They run in order through the Asistente's closed action map, exactly as a voice
 * command's do, and the card shows the reply and what ran.
 */

export const PREPARE_TEXT = {
  tool: 'Preparar estudio',
  title: 'Preparar estudio',
  working: 'preparando la lectura…',
  ran: 'Acciones ejecutadas:',
  none: 'No hubo acciones del visor para preparar.',
  deterministic: 'Plan automático (sin modelo).',
  failed: 'No fue posible preparar el estudio.',
} as const;

export async function prepareStudy(deps: RadiologistDeps): Promise<void> {
  const study = conversationStudy(deps.shell);
  const current = deps.shell.studies().find((s) => s.studyInstanceUID === study);
  const { body } = toolCard(deps, 'prepare', PREPARE_TEXT.title, study);
  loading(body, PREPARE_TEXT.working);
  try {
    const answer = await deps.api.prepare(study, prepareBody((current?.series ?? []).filter(isImageSeries), priorStudies(deps.shell, study)));
    const ran = await runCommandActions({ shell: deps.shell, api: deps.api }, answer.actions, MAX_PREPARE_ACTIONS);
    const nodes: HTMLElement[] = [];
    if (answer.reply) nodes.push(el('div', 'assistant-msg-text', answer.reply));
    if (ran.length === 0) {
      nodes.push(el('div', 'assistant-tool-note', PREPARE_TEXT.none));
    } else {
      nodes.push(el('div', 'assistant-tool-note', PREPARE_TEXT.ran));
      const list = el('ul', 'assistant-command-actions');
      ran.forEach((a) => {
        const item = el('li', 'assistant-command-action', actionLabel(a));
        item.dataset.action = a.type;
        list.appendChild(item);
      });
      nodes.push(list);
    }
    nodes.push(...traceNodes(answer));
    if (!answer.model) nodes.push(el('div', 'assistant-trace', PREPARE_TEXT.deterministic));
    body.replaceChildren(...nodes);
  } catch (error) {
    console.warn('[viewer] prepare study failed', error);
    body.replaceChildren(el('p', 'assistant-tool-note assistant-tool-error', toolFailure(error, 'prepare_study', PREPARE_TEXT.failed)));
  }
}
